/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { ref, onMounted, onUnmounted } from 'vue';
import { isServer } from '../utils/dom.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-b390ff23.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-61150968.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../utils/easing.mjs';

var useMouse = function useMouse() {
  var x = ref(0);
  var y = ref(0);
  var onMouseMove = function onMouseMove(e) {
    x.value = e.clientX;
    y.value = e.clientY;
  };
  if (!isServer) {
    onMounted(function () {
      window.addEventListener("mousemove", onMouseMove, {
        passive: true
      });
    });
    onUnmounted(function () {
      window.removeEventListener("mousemove", onMouseMove);
    });
  }
  return {
    x: x,
    y: y
  };
};

export { useMouse };
//# sourceMappingURL=util.mjs.map
